import userInfoService from "@/services/userInfo";
import store from "@/store";
import { apiWrapper } from "@/services/api";

export const retryIssuedExternalCoupon = async (
  masterBookId,
  bookId,
  isValid = true
) => {
  try {
    const acquireType = isValid ? "valid_book" : "get_book";

    const gettableResponse = await apiWrapper(
      "GET",
      `gettable_coupons?master_book_id=${masterBookId}&acquire_type=${acquireType}`
    );
    const user_id = userInfoService.getUserIdFromIdToken();

    let issuedCount = 0;
    const gettableMasterCouponIds = [];

    //detect which coupons have issued already
    let issuedExternalMasterCouponIds = [];
    if (store.getters["ticketing/issuedExternalMasterCouponIds"] != null) {
      issuedExternalMasterCouponIds = [
        ...store.getters["ticketing/issuedExternalMasterCouponIds"],
      ];
    }

    const failedIssueExternalMasterCouponIds = [];
    const paymentProcessInfo = store.getters["ticketing/paymentProcessInfo"];

    //re-assign failed coupon ids if exist
    if (
      paymentProcessInfo != null &&
      paymentProcessInfo.failed_coupon_ids != null
    ) {
      paymentProcessInfo.failed_coupon_ids.forEach((coupon) => {
        failedIssueExternalMasterCouponIds.push(coupon);
      });
    }

    gettableResponse.data.forEach((coupon) => {
      let isIssued = false;

      //check if it is issued
      if (
        issuedExternalMasterCouponIds != null &&
        issuedExternalMasterCouponIds.length > 0
      ) {
        isIssued =
          issuedExternalMasterCouponIds.findIndex((masterCouponId) => {
            return coupon.master_coupon_id == masterCouponId;
          }) > -1;
      }

      //if failed exist, only retry failed coupons
      if (!isIssued && failedIssueExternalMasterCouponIds.length > 0) {
        const isFailed =
          failedIssueExternalMasterCouponIds.findIndex((masterCouponId) => {
            return coupon.master_coupon_id == masterCouponId;
          }) > -1;

        //not issued + not failed -> no
        //not issued + failed -> yes
        isIssued = !isFailed;
      }

      if (
        !isIssued &&
        coupon.gettable_counts != null &&
        coupon.gettable_counts > 0
      ) {
        gettableMasterCouponIds.push(coupon.master_coupon_id);
      }
    });

    if (gettableMasterCouponIds.length > 0) {
      for (var i = 0; i < gettableMasterCouponIds.length; i++) {
        const issuedCouponResponse = await apiWrapper("POST", "coupons", {
          master_coupon_id: gettableMasterCouponIds[i],
          user_ids: [user_id],
          book_ids: [bookId],
        });

        issuedExternalMasterCouponIds.push(gettableMasterCouponIds[i]);
        store.commit(
          "ticketing/setIssuedExternalMasterCouponIds",
          issuedExternalMasterCouponIds
        );
        issuedCount++;
      }
    } else {
      console.log("retryIssuedExternalCoupon :>> no coupons");
    }

    if (issuedCount < gettableMasterCouponIds.length) {
      throw new Error(
        `Fail to Try Issued External Coupons: ${issuedCount}/${gettableMasterCouponIds.length}`
      );
    }

    return issuedCount;
  } catch (err) {
    console.log('ERROR"" retryIssuedExternalCoupon', err);
    throw err;
  }
};
